<template>
  <div class="footer">
    <div class="social-icons">
      <a
        href="https://www.instagram.com/talentinus/"
        target="_blank"
        rel="noopener"
        class="social-icon"
      >
        <font-awesome-icon :icon="['fab', 'instagram']" size="2xl" />
      </a>
      <a
        href="https://www.tiktok.com/@talentinus?_t=ZS-8xVRvqrGPhp&_r=1"
        target="_blank"
        rel="noopener"
        class="social-icon"
      >
        <font-awesome-icon :icon="['fab', 'tiktok']" size="2xl" />
      </a>
    </div>
    
    <div class="nav-buttons">
      <RouterLink to="/por_que" class="contentFoot" @click="handleNavClick">POR QUE TALENTINUS</RouterLink>
      <RouterLink to="/como_funciona" class="contentFoot" @click="handleNavClick">COMO FUNCIONA</RouterLink>
      <RouterLink to="/resultados" class="contentFoot" @click="handleNavClick">RESULTADOS</RouterLink>
      <RouterLink to="/precios" class="contentFoot" @click="handleNavClick">PRECIOS</RouterLink>
      
      <span class="contentFoot" @click="showTerms = true; handleNavClick()">TÉRMINOS Y CONDICIONES</span>
      <span class="contentFoot" @click="showPrivacy = true; handleNavClick()">POLÍTICAS DE PRIVACIDAD</span>
    </div>
  </div>
  <LegalModal :show="showTerms" @close="showTerms = false">
    <h2>TÉRMINOS Y CONDICIONES</h2>
    <p><strong>Última actualización:</strong> 08/07/2025</p>

    <p>Bienvenido a Talentinus. Al acceder y utilizar este sitio web, aceptas estar sujeto a los siguientes Términos y Condiciones. Te recomendamos leerlos detenidamente.</p>

    <h3>1. Identidad de la Empresa</h3>
    <p>Este sitio web es operado por Talentinus, marca registrada legalmente constituida en México, dedicada a brindar orientación vocacional y mentorías personalizadas para estudiantes y padres de familia.</p>

    <h3>2. Servicios Ofrecidos</h3>
    <p>Talentinus ofrece herramientas digitales, como diagnósticos de talentos, mentorías, asesorías personalizadas, y contenido informativo. Al contratar cualquiera de nuestros servicios, aceptas los lineamientos y tiempos de entrega especificados durante el proceso de compra o registro.</p>

    <h3>3. Condiciones de Uso</h3>
    <p>El uso del sitio está destinado únicamente a personas mayores de edad o a menores acompañados de su tutor legal. No está permitido utilizar nuestros contenidos con fines ilícitos, comerciales no autorizados o de manera que afecte la imagen de la marca.</p>

    <h3>4. Propiedad Intelectual</h3>
    <p>Todos los contenidos visuales, escritos y tecnológicos utilizados en este sitio son propiedad exclusiva de Talentinus. Su reproducción total o parcial está prohibida sin autorización expresa por escrito.</p>

    <h3>5. Modificaciones</h3>
    <p>Talentinus se reserva el derecho de modificar estos términos en cualquier momento. Las actualizaciones serán comunicadas en esta misma sección y entrarán en vigor inmediatamente después de su publicación.</p>

    <h3>6. Contacto</h3>
    <p>Para dudas o aclaraciones, puedes comunicarte con nosotros a través del correo electrónico: <a href="mailto:buzon@talentinus.com">buzon@talentinus.com</a></p>
  </LegalModal>


  <LegalModal :show="showPrivacy" @close="showPrivacy = false">
    <h2>POLÍTICA DE PRIVACIDAD</h2>
    <p><strong>Última actualización:</strong> 08/07/2025</p>

    <p>En Talentinus, la privacidad de nuestros usuarios es una prioridad. Esta política describe cómo recopilamos, usamos, protegemos y compartimos tu información personal.</p>

    <h3>1. Información Recopilada</h3>
    <ul>
      <li>Nombre completo</li>
      <li>Edad y nivel educativo</li>
      <li>Datos de contacto (correo electrónico, teléfono)</li>
      <li>Resultados de evaluaciones y formularios</li>
      <li>Interacciones con chatbots o formularios automatizados</li>
      <li>Datos anónimos de navegación (herramientas de análisis)</li>
    </ul>

    <h3>2. Uso de la Información</h3>
    <ul>
      <li>Brindar diagnósticos vocacionales o mentorías</li>
      <li>Enviar recordatorios y materiales relacionados</li>
      <li>Ofrecer recomendaciones personalizadas</li>
      <li>Analizar tendencias para mejorar la experiencia</li>
      <li>Automatizar atención con chatbots</li>
    </ul>

    <h3>3. Uso de Chatbots</h3>
    <p>Utilizamos sistemas de inteligencia artificial para resolver dudas, guiar procesos y ofrecer seguimiento. Estos pueden registrar la información compartida voluntariamente para mejorar la atención.</p>

    <h3>4. Analítica de Usuario</h3>
    <p>Usamos herramientas como Google Analytics y Meta Pixel para entender la navegación en nuestro sitio. Estos datos son anónimos y puedes desactivar su recopilación en tu configuración de cookies.</p>

    <h3>5. Compartir Información</h3>
    <p>No compartimos tu información personal con terceros, salvo que sea necesario para brindar el servicio o por exigencia legal. Jamás vendemos datos con fines comerciales.</p>

    <h3>6. Seguridad</h3>
    <p>Aplicamos medidas administrativas, técnicas y organizativas para proteger tu información contra accesos no autorizados o mal uso.</p>

    <h3>7. Consentimiento</h3>
    <p>Al usar este sitio o contratar servicios, consientes el tratamiento de tus datos conforme a esta política.</p>

    <h3>8. Derechos ARCO</h3>
    <p>Puedes acceder, rectificar, cancelar u oponerte al tratamiento de tus datos. Contáctanos en <a href="mailto:buzon@talentinus.com">buzon@talentinus.com</a></p>

    <h3>9. Menores de Edad</h3>
    <p>Si eres menor, tu tutor legal debe otorgar el consentimiento para el uso de tus datos y el acceso a nuestros servicios.</p>
  </LegalModal>

</template>

<script>
import LegalModal from './LegalModal.vue'

export default {
  name: 'FooterBar',
  components: { LegalModal },
  data() {
    return {
      showTerms: false,
      showPrivacy: false
    }
  },
  methods: {
    handleNavClick() {
      // Scroll suave al inicio
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Espacio entre social-icons y nav-buttons */
  width: 100%;
  padding: 24px 16px;
  background-color: #06111C;
}

.social-icons {
  display: flex;
  gap: 25px;
  margin-bottom: 0; /* Quita el margen inferior para alineación horizontal */
  padding: 24px 0 24px 60px; /* Padding derecho para separar de los nav-buttons */
}

.social-icon:hover {
  transform: scale(1.1);
  color: #f5f5ff;
}

.nav-buttons {
 display: flex;
  gap: 25px;
  margin-left: auto;
}

.nav-button {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  border: none;
  background-color: #d9d9d9;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 10px;
  line-height: 137%;
  cursor: pointer;
  transition: background-color 0.2s;
}

.nav-button.primary {
  color: #c58911;
}

.nav-button.secondary {
  color: rgba(197, 137, 17, 0.6);
}

.nav-button:hover {
  background-color: #c4c4c4;
}

.nav-button:active {
  background-color: #b0b0b0;
}
.contentFoot {
  color:#C58911;
  padding-right: 30px;
  text-decoration: none;
  font-weight: 600;
  font-size: 10px;
  list-style: 137%;
  transform: scaleY(1);
}

.contentFoot:hover {
  color: #FFFFFF;
}

@media (max-width: 392px) {
  .nav-buttons {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .footer {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 8px;
    gap: 18px;
  }

  .social-icons {
    padding: 8px 0 8px 0;
    gap: 18px;
    justify-content: flex-start;
  }

  .nav-buttons {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    margin-left: 0;
  }

  .contentFoot {
    font-size: 14px !important;
    padding-right: 0 !important;
    padding-bottom: 8px;
    display: block;
    width: 100%;
    text-align: left;
  }
}
</style>
